import { UseKeycloakService } from '@europrocurement/l2d-keycloak';
import { ContactJsonldTiersReadNoteGroupTimestampableBlameambleGroup } from '@europrocurement/l2d-domain/openApi/ApiTiers';
import { useCurrentPrescriber } from './useCurrentPrescriber';

export const useCurrentContact = () => {
    const kc = UseKeycloakService();
    const prescripteur = useCurrentPrescriber();

    const getCurrentContactByEmail = ():
        | ContactJsonldTiersReadNoteGroupTimestampableBlameambleGroup
        | undefined => {
        if (!prescripteur) return undefined;
        const kcEmail = kc.getEmail();
        if (!kcEmail) return undefined;
        return prescripteur.contacts.find(
            (contact) =>
                contact.emailsContact?.find(
                    (email) => email.email?.toLocaleLowerCase() === kcEmail.toLocaleLowerCase(),
                ) !== undefined,
        );
    };

    const getCurrentContactByUserIdentifier = ():
        | ContactJsonldTiersReadNoteGroupTimestampableBlameambleGroup
        | undefined => {
        if (!prescripteur) return undefined;
        return prescripteur.contacts.find(
            (contact) => contact.userIdentifier === kc.getTokenParsed()?.preferred_username,
        );
    };

    const currContact: ContactJsonldTiersReadNoteGroupTimestampableBlameambleGroup | undefined =
        getCurrentContactByEmail();

    return {
        currContact,
        getCurrentContactByEmail,
        getCurrentContactByUserIdentifier,
    };
};
